import { render, staticRenderFns } from "./DefaultTwo.vue?vue&type=template&id=d670458a&scoped=true&"
import script from "./DefaultTwo.vue?vue&type=script&lang=js&"
export * from "./DefaultTwo.vue?vue&type=script&lang=js&"
import style0 from "./DefaultTwo.vue?vue&type=style&index=0&id=d670458a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d670458a",
  null
  
)

export default component.exports